import { NbMenuService } from '@nebular/theme';
import { Component } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'lba-not-found',
  styleUrls: ['./not-found.component.scss'],
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {

  constructor(private menuService: NbMenuService, private location: Location) {
  }

  goToHome() {
    // this.menuService.navigateHome();
    this.location.back();
  }
}
